export const ASSIGNMENT = Object.freeze({
  ASSIGNED: 'assigned',
  UNASSIGNED: 'unassigned',
})
